"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTableToolbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ControlPoint_1 = __importDefault(require("@material-ui/icons/ControlPoint"));
const files_context_1 = require("../../common/files/files-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const table_field_styles_1 = require("../../components/table-field/table-field-styles");
const table_field_context_1 = require("../../components/table-field/table-field-context");
const table_field_toolbar_button_1 = require("../../components/table-field/table-field-toolbar-button");
const snackbar_context_1 = require("../snackbar/snackbar-context");
const snackbar_types_1 = require("../snackbar/snackbar-types");
const file_table_context_1 = require("./file-table-context");
function FileTableToolbar() {
    const classes = table_field_styles_1.useStyles();
    const { disabled, disabledAdd, visibleAdd, saveRow, value } = react_1.useContext(table_field_context_1.TableFieldContext);
    const intl = react_intl_1.useIntl();
    const { uploadFile } = react_1.useContext(files_context_1.FilesContext);
    const { maxItems } = react_1.useContext(file_table_context_1.FileTableContext);
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const handleUpload = event_callback_hook_1.useEventCallback(async (event) => {
        const input = event.currentTarget;
        const files = event.currentTarget.files;
        try {
            if (maxItems !== undefined && value.length + files.length > maxItems) {
                const message = intl.formatMessage({
                    id: 'EAS_FILE_TABLE_MSG_ERROR_UPLOAD_COUNT',
                    defaultMessage: 'Byl překročen maximální povolený počet souborů',
                });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw new Error('Max file size error');
            }
            for (const file of files) {
                const fileRef = await uploadFile(file);
                saveRow(undefined, fileRef);
            }
        }
        finally {
            /*
              Reset file input, so one can load the same file again with trigering the onChange event.
              The event will not be triggered otherwise for the same file.
            */
            input.value = null;
        }
    });
    return (react_1.default.createElement("div", { className: classes.tableActions },
        react_1.default.createElement("div", { className: classes.buttonGroup },
            react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_FILE_TABLE_BTN_ADD", defaultMessage: "P\u0159idat" }), IconComponent: ControlPoint_1.default, disabled: disabled || disabledAdd, show: visibleAdd, component: "label" },
                react_1.default.createElement("input", { type: "file", multiple: true, style: { display: 'none' }, onChange: handleUpload })))));
}
exports.FileTableToolbar = FileTableToolbar;
//# sourceMappingURL=file-table-toolbar.js.map